import type { ApiTableCommandFactory } from 'components/ApiTable/model/ApiTableModel';

export const closeDescriptionModal: ApiTableCommandFactory =
  (cmdContext) => async () => {
    cmdContext.updateState((draft) => {
      draft.description.open = false;
    });
  };
